<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="d_flex_btwn">
          <h5 class="common_subtitle pb_20  font_16p pt_20">Audit Log</h5>
        </div>
        <div class="d_flex_start">
          <div class="mb-3 me-3">Resource</div>
          <div class="mb-3">
            <select class="form-select width_200p" id="policy_group" v-model="filter.resource"
                    @change="filterByResource(filter.resource)"
            >
              <option value="">Select resource</option>
              <option v-for="(resource, uIndex) in resources" :key="'server'+uIndex" :value="resource.id">
                {{ reformatText(resource.loggable_type) }}
              </option>
            </select>
          </div>
          <div class="ms-3 mb-3">
            <div>Period</div>
          </div>
          <div class="ms-3 mb-3">
            <select class="form-control" v-model="filter.start_year">
              <option value="">Select year</option>
              <option value="2024">2024</option>
              <option value="2023">2023</option>
              <option value="2022">2022</option>
            </select>
          </div>
          <div class="ms-3 mb-3">
            <select class="form-control" v-model="filter.start_month">
              <option value="">Select month</option>
              <option value="January">January</option>
              <option value="February">February</option>
              <option value="March">March</option>
              <option value="April">April</option>
              <option value="May">May</option>
              <option value="June">June</option>
              <option value="July">July</option>
              <option value="August">August</option>
              <option value="September">September</option>
              <option value="October">October</option>
              <option value="November">November</option>
              <option value="December">December</option>
            </select>
          </div>
          <div class="ms-3 mb-3">
            <div>-</div>
          </div>
          <div class="ms-3 mb-3">
            <select class="form-control" v-model="filter.end_year">
              <option value="">Select year</option>
              <option value="2024">2024</option>
              <option value="2023">2023</option>
              <option value="2022">2022</option>
            </select>
          </div>
          <div class="ms-3 mb-3">
            <select class="form-control" v-model="filter.end_month">
              <option value="">Select month</option>
              <option value="January">January</option>
              <option value="February">February</option>
              <option value="March">March</option>
              <option value="April">April</option>
              <option value="May">May</option>
              <option value="June">June</option>
              <option value="July">July</option>
              <option value="August">August</option>
              <option value="September">September</option>
              <option value="October">October</option>
              <option value="November">November</option>
              <option value="December">December</option>
            </select>
          </div>
          <div class="ms-3 mb-3">
            <button type="button" class="btn btn-dark width_100p" @click.prevent="filterByYearMonth()">
              Check
            </button>
          </div>
          <div class="ms-3 mb-3">
            <button type="button" class="btn btn-outline-primary width_100p" @click.prevent="loadData()">
              Refresh
            </button>
          </div>
        </div>

        <cloud-table-component
            :columns="columns"
            :rows="inquiries"
            :sortable="sortable"
            :pagination="pagination"
            @sorting="sorting"
            @pageChanged="pageChanged">
          <template v-slot:loggable_type="{ row }">
            {{ reformatText(row.loggable_type) }}
          </template>

          <template v-slot:action="{ row }">
            <button type="button" class="btn btn-outline-primary btn-sm mr_15" @click.prevent="openModal(row)">
              <i class="material-symbols-outlined font_16p">visibility</i>
            </button>
          </template>
        </cloud-table-component>
      </div>
    </div>

    <BaseModal
        v-if="isShowInquiryModal"
        title="Log Info"
        :closeModal="closeModal"
        size="modal_1080p"
    >
      <AuditLogInfo
          :closeModal="closeModal"
          :loadData="loadData"
          :record="record"
      />
    </BaseModal>

  </div>
</template>

<script>
import CloudTableComponent from "@/components/shared/CloudTableComponent.vue";
import BaseModal from "@/components/BaseModal.vue";
import AuditLogInfo from "@/views/iam/AuditLogInfo.vue";

export default {
  name: "AuditLog",
  components: {AuditLogInfo, BaseModal, CloudTableComponent},
  data() {
    return {
      inquiries: [],
      filter: {
        resource: '',
        start_year: '',
        start_month: '',
        end_year: '',
        end_month: '',
        loggable_id: '',
        loggable_type: '',
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'user_id',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      },
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },
      columns: [
        {
          label: "Resource",
          field: "loggable_type",
          slot: true,
        },
        {
          label: "User",
          field: "actor.name",
          sortable: false,
        },
        {
          label: "Event",
          field: "action",
          sortable: true,
        },
        {
          label: "Created At",
          field: "created_at",
        },
        {
          label: "Action",
          field: "action",
          sortable: false,
          slot: true,
        },
      ],
      pagination: null,
      isShowInquiryModal: false,
      record: null,
      selectedRecord: null,
      users: [],
      resources: [],
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === from.name && !window._.isEqual(to, from)) {
        this.setQueryData(this.getAllQueryParams())
        this.loadData()
      }
    },
  },
  mounted() {
    const query = this.getAllQueryParams()
    if (query.page) {
      this.setQueryData(query)
    }
    this.loadData()
    this.getResourceList()
  },
  methods: {
    setQueryData(query) {
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page
      }

      this.filter = {
        resource: query.resource,
        start_month: query.start_month,
        start_year: query.start_year,
        end_year: query.end_year,
        end_month: query.end_month,
        loggable_id: query.loggable_id,
        loggable_type: query.loggable_type,
      }

      this.sortable = {
        order: query.sort,
        sort: query.sort_order
      }
    },
    resetAll() {
      this.sortable = {
        order: 'created_at',
        sort: 'desc'
      }

      this.filter = {
        resource: '',
        start_year: '',
        start_month: '',
        end_year: '',
        end_month: '',
        loggable_id: '',
        loggable_type: '',
      }

      this.queryParams = {
        page: 1,
        search: '',
        search_columns: 'user_id',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      }

      this.changeRoute();
      this.loadData();
    },
    searchQuery() {
      this.changeRoute();
    },
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute()
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute()
    },
    changeRoute() {
      this.$router.push({
        name: this.$route.name,
        query: {
          ...this.queryParams,
          ...this.filter
        }
      });
    },
    loadData() {
      this.lyLoading = true
      this.axios.get('/audit-logs', {
        params: {
          ...this.queryParams,
          ...this.filter
        }
      })
          .then(({data}) => {
            this.inquiries = data.data
            this.pagination = data.meta;
          })
          .finally(() => {
            this.lyLoading = false;
          })
    },
    checkSingleData(user, event) {
      event.target.blur();
      if (this.selectedRecord?.id === user.id) {
        this.selectedRecord = null;
      } else {
        this.selectedRecord = user;
      }
    },
    deleteRecord() {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/policy-groups/' + this.selectedRecord.id)
              .then((response) => {
                if (response.data.success) {
                  this.selectedRecord = null;
                  this.showSuccessMsg(response.data.message);
                  this.loadData();
                } else {
                  this.showFailMsg(response.data.message)
                }
              });
        }
      });
    },
    openModal(record = null) {
      this.record = record
      this.isShowInquiryModal = true;
    },
    closeModal() {
      this.isShowInquiryModal = false;
    },
    getUsers(){
      this.axios.get('/customers').then(({ data }) => {
        this.users = data.data
      })
    },
    filterByResource(resourceId){
      this.queryParams.page = 1;

      if (resourceId) {
        const selectedResource = this.resources.find(
            (resource) => resource.id === resourceId
        );

        this.filter.loggable_id = selectedResource.loggable_id;
        this.filter.loggable_type = selectedResource.loggable_type;
      } else {
        this.filter.loggable_id = '';
        this.filter.loggable_type = '';
      }
      this.changeRoute()
    },
    filterByYearMonth(){
      this.queryParams.page = 1 ;
      this.changeRoute()
    },
    reformatText(text){
      return text.replace(/App\\Models\\(Cloud\\)?/, "");
    },
    getResourceList(){
      this.axios.get('/get-audit-log-resources').then(({ data }) => {
        this.resources = data
      })
    }
  }
}
</script>

<style scoped>

</style>